export const EMPTY_STATE_CONTENT = {
  title: 'No FIO Handles',
  message: 'There are no FIO Handles in all your wallets',
};

export const WARNING_CONTENT = {
  LOW_BUNDLES: {
    title: 'Low Bundles',
    message:
      'Low Bundles - Your remaining bundles amount is low, please add more bundles.',
  },
  EXPIRED_DOMAINS: {
    title: 'FIO Handle Domain(s) Expired',
    message:
      'One or more FIO Handle Domain has expired. Certain FIO Handle actions are inactive until the domain is renewed. Renew today to restore the actions.',
  },
};
